import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import {
  StyledHowItWorks,
  GradientBlob1,
  GradientBlob2,
  ContentContainer,
  HeaderContainer,
  SectionTitle,
  SectionSubtitle,
  StepCard,
  StepNumber,
  StepContent,
  StepTitle,
  StepDescription,
} from "./HowItWorks.styles";
import { SectionContentWrapper } from "../../styled";

export const HowItWorks: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      title: t("home.howItWorks.step1.title"),
      description: t("home.howItWorks.step1.description"),
    },
    {
      number: "02",
      title: t("home.howItWorks.step2.title"),
      description: t("home.howItWorks.step2.description"),
    },
    {
      number: "03",
      title: t("home.howItWorks.step3.title"),
      description: t("home.howItWorks.step3.description"),
    },
  ];

  return (
    <StyledHowItWorks>
      <GradientBlob1 />
      <GradientBlob2 />
      <SectionContentWrapper>
        <ContentContainer>
          <HeaderContainer>
            <SectionTitle>{t("home.howItWorks.title")}</SectionTitle>
            <SectionSubtitle>{t("home.howItWorks.subtitle")}</SectionSubtitle>
          </HeaderContainer>

          <Row gutter={[48, 48]}>
            {steps.map((step) => (
              <Col key={step.number} sm={24} md={8}>
                <StepCard>
                  <StepNumber>{step.number}</StepNumber>
                  <StepContent>
                    <StepTitle>{step.title}</StepTitle>
                    <StepDescription>{step.description}</StepDescription>
                  </StepContent>
                </StepCard>
              </Col>
            ))}
          </Row>
        </ContentContainer>
      </SectionContentWrapper>
    </StyledHowItWorks>
  );
};
